export enum DurationMeasure {
  MINUTES = 'Minutes',

  HOURS = 'Hours',

  DAYS = 'Days',
}
